import {Component} from '@angular/core';
import {DecimalPipe} from "@angular/common";
import {NgbPagination} from "@ng-bootstrap/ng-bootstrap";
import {Page} from "../../../../../generated-model/model";
import {ReactiveFormsModule} from "@angular/forms";

@Component({
  selector: 'app-change-health-insurance',
  standalone: true,
  imports: [
    DecimalPipe,
    NgbPagination,
    ReactiveFormsModule
  ],
  templateUrl: './change-health-insurance.component.html',
  styleUrl: './change-health-insurance.component.scss'
})
export class ChangeHealthInsuranceComponent {
  pageData: Page<any> = {size: 10};

  search(page: number = 1) {

  }
}
